import components from '@witkac/bootstrap4-components/src/components/formComponents';
import { schemaMixin } from '@witkac/jschema';

/**
 * @vuese
 * @group mixins
 *
 * Mixin formularzy, przyspiesza importowanie `@witkac/bootstrap4-components`
 */
export const formMixin = {
  mixins: [schemaMixin],
  components: components,
  external: {},
  data() {
    return { model: {} };
  }
};
